import produce from 'immer';
import types from './types';
import initialState from './initialState';
import { ruleCounts } from '../../data/difficulty';

// eslint-disable-next-line consistent-return
export default produce((draft, { type, data }) => {
  switch (type) {
    case types.SET_NUMBER_OF_PLAYERS: {
      draft.numberOfPlayers = parseInt(data, 10);

      break;
    }

    case types.SET_DIFFICULTY: {
      draft.difficulty = data;
      draft.initialRuleCount = ruleCounts[data].initialRuleCount;
      draft.phaseRuleCount = ruleCounts[data].phaseRuleCount;

      break;
    }

    case types.SET_SHOW_INCLUDED_SKILLS: {
      draft.showIncludedSkills = data;

      break;
    }

    case types.SET_SHOW_ACTIVE_SKILLS: {
      draft.showActiveSkills = data;

      break;
    }

    case types.SET_SHOW_PASSIVE_SKILLS: {
      draft.showPassiveSkills = data;

      break;
    }

    case types.SET_SHOW_PHASE_MODAL: {
      draft.showPhaseModal = data;

      break;
    }

    case types.SET_SHOW_RULE_ROLL_MODAL: {
      draft.showRuleRollModal = data;

      break;
    }

    case types.RESTART_GAME: {
      return initialState;
    }

    case types.RESTORE_SETTINGS: {
      draft.numberOfPlayers = data.numberOfPlayers;
      draft.difficulty = data.difficulty;
      draft.initialRuleCount = data.initialRuleCount;
      draft.phaseRuleCount = data.phaseRuleCount;
      draft.showIncludedSkills = data.showIncludedSkills;
      draft.showActiveSkills = data.showActiveSkills;
      draft.showPassiveSkills = data.showPassiveSkills;

      break;
    }

    case types.SHOW_SESSION_TOKEN: {
      draft.showSessionToken = data;

      break;
    }

    case types.SHOW_SESSION_MENU: {
      draft.showSessionMenu = data;

      break;
    }

    default: {
      break;
    }
  }
}, initialState);
